export function isValidUrl(url) {
  if (!url || typeof url !== 'string') return false
  try {
    const parsed = new URL(url)
    return ['http:', 'https:', 'ftp:'].includes(parsed.protocol)
  } catch {
    return false
  }
}

export function safeOpenUrl(url, target = '_blank') {
  if (!isValidUrl(url)) {
    console.warn('Tentative d\'ouverture d\'URL invalide bloquée:', url)
    return
  }
  window.open(url, target, 'noopener,noreferrer')
}
